import React, { CSSProperties } from 'react';

interface OwnProps {
  name: string;
  rating: number;
  fillPercentWidth: number;
  wrapperStyle?: CSSProperties;
  nameStyle?: CSSProperties;
  ratingStyle?: CSSProperties;
  barStyle?: CSSProperties;
  barFillStyle?: CSSProperties;
}

const ReviewBreakdownItem = ({
  name,
  rating,
  fillPercentWidth,
  wrapperStyle,
  nameStyle,
  ratingStyle,
  barStyle,
  barFillStyle,
}: OwnProps) => {
  return (
    <div className="flex items-center justify-between m-2" style={wrapperStyle}>
      <p style={nameStyle}>{name}</p>
      <div className="flex items-center">
        <span style={ratingStyle}>{rating.toFixed(1)}</span>
        <div
          className="br-2 overflow-hidden relative h-3 bg-white min-w-[130px]"
          style={barStyle}
        >
          <div
            style={{ ...barFillStyle, width: `${fillPercentWidth}%` }}
            className="absolute top-0 left-0 h-3 bg-green-500 br-2"
          />
        </div>
      </div>
    </div>
  );
};

export default ReviewBreakdownItem;
